<template>
    <div :class="['page-card', { sm }]">
        <h2 v-if="title" class="page-card-title px-2 pt-2">{{ title }}</h2>
        <hr v-if="hr" class="my-3" />
        <div class="page-card-content p-2">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        sm: {
            type: Boolean,
            default: false,
        },
        hr: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "",
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.page-card {
    background: $cardBg;
    padding: 24px;
    border-radius: $radiusLg;
    box-shadow: $shadowSm;
    border: 1px solid $gray200;
    height: 100%;
    transition: box-shadow $transitionBase, transform $transitionBase;

    &:hover {
        box-shadow: $shadowMd;
    }

    &.sm {
        padding: 8px 16px;
    }
}
.page-card-title {
    color: $gray800;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -0.01em;
}
.page-card-content {
    margin-top: 12px;
}

/* ---- Tablet ---- */
@media (max-width: 768px) {
    .page-card {
        padding: 18px;
        border-radius: $radiusMd;
    }
}
/* ---- Mobile ---- */
@media (max-width: 480px) {
    .page-card {
        padding: 14px;
        border-radius: $radiusSm;
    }
    .page-card-title {
        font-size: 15px;
    }
}
</style>
